export const isNumber = (str) => {
    return /([0-9]+|\.)/.test(str);
};
